export default __webpack_public_path__ + "static/media/slack.08622e36.png";